export function sortArray<T>(data: T[], sortKey: keyof T, sortDirection = 'ASC' as 'ASC' | 'DESC'): T[] {
    return data?.length ? [...data].sort((a, b) => {
        if (sortDirection === 'ASC') {
            return a[sortKey] > b[sortKey] ? 1 : -1;
        }
        return a[sortKey] > b[sortKey] ? -1 : 1;
    }) : [];
}
